import React, { useEffect, useState } from "react";
import Immutable from "immutable";
import { getCategoryCount } from "../../pages/inventory/Inventory";
import { CollapseItemsInfo } from "../summary/InventoryList";
import navigationsLinks from "../../constants/navigation_links";
import { useHistory } from "react-router";

import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { getCustomItemsCount } from "../../pages/inventory/Inventory";

export default function DashboardInventoryList(props) {
  const inventoryData = Immutable.fromJS(props.inventoryItems);
  const history = useHistory();
  const estimateId = props.estimateId;
  const propertySize = props.propertySize;
  const { editDisabled } = props;
  const JSX = inventoryData
    .get("inventory")
    .filter((data, index) => {
      return getCategoryCount(data) > 0 ? true : false;
    })
    .map((data, index) => {
      return (
        <CollapseItemsInfo
          mainCategory={data}
          mapIndex={index}
          showAllList={false}
        />
      );
    })
    .toArray();
  return (
    <div className="move-inventory-details-container">
      <div className="d-flex flex-row align-items-center justify-content-between my-4">
        <h3 className="m-0 mr-2">Inventory Details</h3>
        {editDisabled === false && (
          <button
            className="btn btn-dark btn-sm"
            onClick={() =>
              history.push(
                `${navigationsLinks.edit_inventory_page}${estimateId}/${propertySize}/update`
              )
            }
          >
            Edit Inventory
          </button>
        )}
      </div>
      {JSX}
      <CustomItemsCollapse showAllList={false} inventoryData={inventoryData} />
    </div>
  );
}
export function CustomItemsCollapse(props) {
  const { showAllList, inventoryData } = props;

  const customItemscount = getCustomItemsCount(inventoryData);
  const [isOpen, setIsOpen] = useState(false);
  const customItemsList = inventoryData.getIn(["customItems", "items"]);
  const units =
    inventoryData.getIn(["customItems", "units"]) === "feet" ? "Ft" : "Mts";
  let JSX = <></>;
  useEffect(() => {
    if (showAllList === true) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [showAllList]);
  if (customItemscount > 0) {
    JSX = (
      <>
        <div className="card inventory-catergory-list-group border-0">
          <div
            className="inventory-title mb-1 d-flex justify-content-between align-items-center"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <h3 className="m-0 p-1 active-color text-active">
              Custom Items
              <span className="count mx-2 btn pill badge btn-sm rounded-circle">
                {getCustomItemsCount(inventoryData)}
              </span>
            </h3>
            <div className="collapse-icon">
              {isOpen === true ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <FontAwesomeIcon icon={faChevronDown} />
              )}
            </div>
          </div>
          <Collapse isOpen={isOpen}>
            <div id="customItemsCollapse" className="container p-0">
              <div className="row">
                {customItemsList
                  .map((item, index) => {
                    return (
                      <div
                        className="col-sm-12 col-md-12 col-lg-12 col-xl-12"
                        key={item.get("id")}
                      >
                        <div className="my-1 mx-2">
                          <div className="inventory-details">
                            <div className="item-info-container">
                              <div className="basic-info">
                                <h2> {item.get("item_name")}</h2>
                              </div>
                              <div className="units-info">
                                L:{`${item.get("item_length")} ${units}`}
                              </div>
                              <div className="units-info">
                                W:{`${item.get("item_width")} ${units}`}
                              </div>
                              <div className="units-info">
                                H:{`${item.get("item_height")} ${units}`}
                              </div>
                              <div className="units-info">
                                <p>{item.get("item_description")}</p>
                              </div>
                              <div className="qty-and-action">
                                <div className="btn-group">
                                  <span className="d-flex align-items-center bg-white clear-btn-white-theme mr-1 qty-count">
                                    {item.get("item_qty")}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                  .toArray()}
              </div>
            </div>
          </Collapse>
        </div>
      </>
    );
    return JSX;
  }
  return JSX;
}

export function EditInventoryOnCallBack(props) {
  const { editDisabled, estimateId, propertySize } = props;
  const history = useHistory();
  const JSX = (
    <>
      <div className="move-inventory-details-container">
        <div className="d-flex flex-row align-items-center justify-content-between my-4">
          <h3 className="m-0 mr-2">Inventory Details</h3>
          {editDisabled === false && (
            <button
              className="btn btn-dark btn-sm"
              onClick={() =>
                history.push(
                  `${navigationsLinks.edit_inventory_page}${estimateId}/${propertySize}/new`
                )
              }
            >
              Edit Inventory
            </button>
          )}
        </div>
          <div className="border rounded border-danger my-4 p-3">
            Your items list is empty. Edit inventory to add items to your list.
          </div>
      </div>
    </>
  );
  return JSX;
}
